

























































































import {
  Building as BuildingEnum,
  Condition as ConditionEnum,
  Event,
  Operator as OperatorEnum,
} from "@gaia-project/engine";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Building from "./Building.vue";
import Condition from "./Condition.vue";
import Operator from "./Operator.vue";
import Resource from "./Resource.vue";
import SpecialAction from "./SpecialAction.vue";

@Component({
  components: {
    Building,
    Condition,
    Operator,
    Resource,
    SpecialAction,
  },
})
export default class TechContent extends Vue {
  @Prop()
  event!: Event;

  get content(): string {
    return this.event.spec;
  }

  get cornerReward() {
    if (
      this.event.operator === OperatorEnum.Trigger ||
      this.event.operator === OperatorEnum.Pass ||
      (this.event.operator === OperatorEnum.Once && this.event.condition !== ConditionEnum.None)
    ) {
      return this.event.rewards[0];
    }

    return null;
  }

  get centerRewards() {
    if (this.event.operator === OperatorEnum.Once && this.event.condition === ConditionEnum.None) {
      return this.event.rewards;
    }

    return [];
  }

  get condition() {
    return this.event.condition;
  }

  get rightRewards() {
    if (this.event.operator === OperatorEnum.Income) {
      return this.event.rewards;
    }

    return [];
  }

  get showText() {
    if (
      this.event.operator === OperatorEnum.Activate ||
      this.event.operator === OperatorEnum.Income ||
      this.event.operator === OperatorEnum.FourPowerBuildings
    ) {
      return false;
    }

    if (
      this.event.operator === OperatorEnum.Once ||
      this.event.operator === OperatorEnum.Trigger ||
      this.event.operator === OperatorEnum.Pass
    ) {
      if (
        [
          ConditionEnum.None,
          ConditionEnum.Federation,
          ConditionEnum.BigBuilding,
          ConditionEnum.AdvanceResearch,
          ConditionEnum.MineOnGaia,
          ConditionEnum.PlanetType,
          ConditionEnum.Sector,
          ConditionEnum.Gaia,
          ConditionEnum.Trade,
          ...Object.values(BuildingEnum),
        ].includes(this.event.condition as any)
      ) {
        return false;
      }
    }

    return true;
  }

  get isAction() {
    return this.event.operator === OperatorEnum.Activate;
  }

  get rewards() {
    return this.event.rewards;
  }

  get flat() {
    return this.$store.state.preferences.flatBuildings;
  }
}
